import { Component } from '@angular/core';

@Component({
  selector: 'app-chevron-left',
  imports: [],
  templateUrl: './chevron-left.html',
  styleUrl: './chevron-left.css'
})
export class ChevronLeft {

}
